import { Constants } from '@areapif/areapif-backend'

import type { InspectionService } from '../models/activeInspection'

/**
 * Every service, in the order the database enum declares them.
 *
 * Read straight off `Constants.public.Enums.service` rather than written out
 * here, so a service the enum gains cannot go missing from the filter that
 * offers them — the same reasoning, and the same shape, as
 * `INSPECTION_LEVELS`. The annotation ties the generated enum to the
 * `InspectionService` the rest of the app renders, so were the two to drift,
 * this line stops compiling instead of the filter quietly offering a service no
 * row can carry.
 */
export const INSPECTION_SERVICES: readonly InspectionService[] = Constants.public.Enums.service
